module.exports = __webpack_public_path__ + "img/pig.053d5c48.png";